import { api, handleError } from "./baseApi";

export async function getBookings(filters = {}) {
  const params = { ...filters };
  Object.keys(params).forEach((key) => {
    if (
      params[key] === undefined ||
      params[key] === null ||
      params[key] === ""
    ) {
      delete params[key];
    }
  });

  try {
    const { data } = await api.get("/booking", { params });
    return data;
  } catch (error) {
    return handleError(error);
  }
}

export async function getBookingById(bookingId) {
  try {
    const { data } = await api.get(`/booking/${bookingId}`);
    return data;
  } catch (error) {
    return handleError(error);
  }
}

export async function cancelTicketById(bookingId) {
  try {
    const { data } = await api.patch(`/booking/${bookingId}/cancel`);
    return data;
  } catch (error) {
    return handleError(error);
  }
}
